export default "__VITE_ASSET__Bxbj_Mfh__"